<template>
  <div class="box2">
    <pageTitle
      title="AI大模型&nbsp;—&nbsp;不能错过的历史机遇"
      titleColor="#081745"
    />
    <div class="content">
      <div class="numberTitle">
        <img class="a" src="../../../assets/coursePage/ai2/box1/01.png" alt />
        <span
          >所有产品都将被大模型重构，<br />
          大模型将成为互联网从业者必备技能</span
        >
      </div>
      <div class="contentBottom">
        <div class="contentBottom01">
          <img src="../../../assets/coursePage/ai2/box1/img01.png" />
          <img src="../../../assets/coursePage/ai2/box1/img02.png" />
          <p>以上信息来源于2023阿里云峰会、知名科技评论人罗超Pro</p>
        </div>
        <div class="contentBottom02">
          <div class="top">
            <img src="../../../assets/coursePage/ai2/box1/img03.png" />
            <p>你一定要学习大模型！</p>
          </div>
          <div class="bottom">
            <span>
              <a>从小的方面说</a>
              <img
                class="i"
                src="../../../assets/coursePage/ai2/box1/line.png"
              />
            </span>
            <h1>能帮你找到更好的工作</h1>
            <span class="second">
              <a>从大的方面说</a>
              <img
                class="i"
                src="../../../assets/coursePage/ai2/box1/line.png"
              />
            </span>
            <h1>让你有机会抓住时代的脉搏</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="numberTitle">
        <img class="a a2" src="../../../assets/coursePage/ai2/box1/02.png" alt />
        <span
          >大模型时代，企业对人才的需求变了<br />
          AIGC相关岗位人才难求，薪资持续走高</span
        >
      </div>
      <div class="contentBottom2">
        <div class="money">
          <span>
            <h1>40,968<i>/月</i></h1>
            <p>NLP算法工程师薪资平均值约</p>
          </span>
          <em></em>
          <span>
            <h1>37,230<i>/月</i></h1>
            <p>大模型算法薪资平均值约</p>
          </span>
        </div>
        <img src="../../../assets/coursePage/ai2/box1/img04.png" />
        <p>数据来源于看准网、boss直聘</p>
      </div>
      <div class="summary">
        <h1>AI大模型是有史以来最大的<br/>
        平台革命，它会重构人类的工作</h1>
        <p>—李开复</p>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.box2 {
  background: #e8f1ff;
  padding: 80px 0 0;
  .numberTitle {
    position: relative;
    text-align: center;
    height: 202px;
    margin: 28px 0 0;
    padding-bottom: 48px;
    .a {
      width: 60px;
      height: 60px;
    }
    .a2{
      width: 72px;
    }
    span {
      display: block;
      position: absolute;
      top: 40px;
      width: 100%;
      left: 0;
      background: linear-gradient(
        270deg,
        rgba(237, 244, 255, 0) 0%,
        #e3f2ff 53%,
        rgba(228, 244, 255, 0) 100%
      );
      border: 2px solid;
      border-image: linear-gradient(
          270deg,
          rgba(255, 255, 255, 0),
          rgba(255, 255, 255, 1),
          rgba(255, 255, 255, 0)
        )
        2 2;
      backdrop-filter: blur(2px);
      text-align: center;
      padding: 24px 0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #081745;
      line-height: 52px;
      text-align: center;
      font-style: normal;
    }
  }
  .contentBottom {
    padding: 0 32px;
    .contentBottom01 {
      background: rgba(255, 255, 255, 0.5);
      box-shadow: inset 0px -2px 0px 0px #ffffff;
      border-radius: 40px;
      border: 2px solid #ffffff;
      padding: 40px 40px 20px;
      img {
        width: 100%;
        margin-bottom: 20px;
      }
      img:first-child {
        margin-bottom: 16px;
      }
      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 22px;
        color: #8A94B4;
        line-height: 32px;
        text-align: center;
        font-style: normal;
      }
    }
    .contentBottom02 {
      margin-top: 30px;
      margin-bottom: 80px;
      background: rgba(255, 255, 255, 0.5);
      box-shadow: inset 0px -2px 0px 0px #ffffff;
      border-radius: 40px;
      overflow: hidden;
      border: 2px solid #ffffff;

      box-sizing: border-box;
      .top {
        padding: 16px;
        background: linear-gradient(
          270deg,
          rgba(72, 147, 253, 0.67) 0%,
          #0069ff 100%
        );
        border-radius: 4px;
        display: flex;
        align-items: center;
        img {
          width: 198px;
          margin-right: 22px;
        }
        p {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 36px;
          color: #ffffff;
          line-height: 68px;
          text-align: left;
          font-style: normal;
        }
      }
      .bottom {
        padding: 0 32px 40px;
        span {
          margin-top: 32px;
          display: flex;
          align-items: center;
          padding-left: 32px;
          box-sizing: border-box;
          a {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 32px;
            color: #051648;
            line-height: 44px;
            text-align: left;
            font-style: normal;
            margin-right: 24px;
            width: 192px;
            white-space:nowrap;
          }
          .i {
            height: 3px;
            flex: 1;
            display: block;
          }
        }
        .second {
          margin-top: 40px;
        }
        h1 {
          margin-top: 16px;
          background: rgba(255, 255, 255, 0.5);
          box-shadow: inset 0px -2px 0px 0px #ffffff;
          border-radius: 18px;
          border: 2px solid #ffffff;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 32px;
          color: #0169ff;
          line-height: 80px;
          height: 80px;
          text-align: left;
          font-style: normal;
          padding-left: 32px;
          box-sizing: border-box;
        }
      }
    }
    
  }
  .contentBottom2 {
   
    >img{
      width: 100%;
      margin-top: 8px;
    }
    >p{
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #A1A8BC;
      line-height: 34px;
      text-align: center;
      font-style: normal;
      position: relative;
      top: -20px;
    }
    .money {
      margin: 0 32px;
      display: flex;
      align-items: center;
      height: 210px;
      background: rgba(255, 255, 255, 0.5);
      border-radius: 16px;
      padding-left: 26px;
      span {
        h1 {
          text-align: center;
          font-family: Arial, Arial;
          font-weight: 900;
          font-size: 50px;
          color: #0069ff;
          line-height: 72px;
          letter-spacing: 1px;
          text-align: center;
          font-style: normal;
          i {
            font-size: 32px;
          }
          margin-bottom: 12px;
        }
        p {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 24px;
          color: #081745;
          line-height: 34px;
          text-align: center;
          font-style: normal;
        }
      }
      em{
        width: 4px;
        height: 130px;
        border-right: 2px solid #FFFFFF;
        margin: 0 36px 0 4px;
      }
    }
  }
  .summary{
      background: url("../../../assets/coursePage/ai2/box1/img05.png") no-repeat;
      background-size: cover;
      background-position: center;
      height: 284px;
      box-sizing: border-box;
      padding: 42px 0 0 0;
      margin-top: 40px;
      h1{
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 48px;
        color: #FFFFFF;
        line-height: 66px;
        text-align: center;
        font-style: normal;
        margin-bottom: 22px;
      }
      p{
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 32px;
        color: #FFFFFF;
        line-height: 44px;
        text-align: right;
        font-style: normal;
        padding-right: 22px;
      }
    }
}
</style>
